import React from 'react'
import {getLink} from '../../../../../../../helpers/utilities'
import {useDownloadTemplateQuery} from '../../../../../../../redux/api/services/batch'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../../../redux/store'

type Props = {
  className?: string
}

export const DownloadTemplate = ({className}: Props) => {
  const infoState = useSelector((state: RootState) => state.info)
  const {data, isSuccess} = useDownloadTemplateQuery({info: infoState})

  return (
    <>
      {isSuccess && (
        <div className={`fs-3 fw-semibold fst-italic ${className}`}>
          <span className='text-primary-dark'>¿No tienes la plantilla?</span>
          <a href={getLink(data)} download='planitlla-lotes.xlsx' className='text-primary'>
            {' '}
            Descárgala aquí.
          </a>
        </div>
      )}
    </>
  )
}
